<template>
	<div class="page" id="product_activity_start">
		<product-image v-if="activity.PhotoVersion" />

		<div class="container start-modal">
			<product-name
				v-if="activeProductDetails"
				:DisplayPrice="DisplayPrice"
				:productName="activeProductDetails.Name"
				:clientName="client.Name"
				:duration="activity.Duration"
				:ageMinimum="activity.AgeMinimum"
				:difficulty="activity.Difficulty"
				:minHeight="activity.MinHeight"
				:privateToursOnly="activity.PrivateToursOnly"
			/>
			<pre>
Overlapped Activities Modal for {{ _uid }}: {{
					overlappedActivitiesModal
				}} </pre
			>
			<pre>showAllTimes: {{ showAllTimes }}</pre>
			<pre>
activeProductDetails.DisplayPrice: {{ activeProductDetails.DisplayPrice }}</pre
			>
			<pre>
activeProductDetails.DisplayDiscount: {{
					activeProductDetails.DisplayDiscount
				}}</pre
			>

			<pre>activity.HotelLatitude: {{ activity.HotelLatitude }}</pre>
			<pre>activity.HotelLongitude: {{ activity.HotelLongitude }}</pre>
			<pre>activity.HotelName: {{ activity.HotelName }}</pre>
			<pre>activity.HotelAddress: {{ activity.HotelAddress }}</pre>
			<pre v-if="activity.SelectedTimes">
activity.SelectedTimes: {{ activity.SelectedTimes.length }}</pre
			>
			<pre v-if="activity.clearedTimes">
activity.clearedTimes: {{ activity.clearedTimes.length }}</pre
			>
			<pre>activity.CapacityTypeKey: {{ activity.CapacityTypeKey }}</pre>

			<code>
				Note: CapacityTypeKey of 2 or 3 works like LargeGroupMode wherein you
				select the date first. However, unlike LargeGrouMode, only one time can
				be selected.
			</code>
			<code>LargeGroupMode is not allowed when CapacityTypeKey == 2 || 3</code>
			<h3 id="book_now_heading" class="mt-1 mb-0 pt-2 pb-2">Book Now</h3>

			<private-ui
				:privateTourRateName="activity.PrivateTourRateName"
				:privateTourRateDescription="activity.PrivateTourRateDescription"
				:privateToursOnly="activity.PrivateToursOnly"
				v-if="activity.EnablePrivateTours && !activity.PrivateToursOnly"
				v-model="activity.IsPrivateTour"
				@privateSelection="handlePrivateSelection($event)"
				ref="privateUi"
			></private-ui>

			<transportation-ui
				v-if="activeProductDetails.Activities"
				v-show="activeProductDetails.OfferTransportation"
				:entityHierarchyKey="activity.EntityHierarchyKey"
				:activity="activeProductDetails.Activities[0]"
				:showAllTimes="showAllTimes"
			/>

			<pre>IsLargeGroup: {{ IsLargeGroup }}</pre>
			<pre>
activeProductDetails.DisableLargeGroup: {{
					activeProductDetails.DisableLargeGroup
				}}</pre
			>
			<pre>activity.EnablePrivateTours: {{ activity.EnablePrivateTours }}</pre>
			<pre>activity.PrivateToursOnly: {{ activity.PrivateToursOnly }}</pre>
			<pre>activity.IsPrivateTour: {{ activity.IsPrivateTour }}</pre>

			<guest-ui
				:activityRates="activityRates"
				:isPrivateTour="activity.IsPrivateTour"
				:entityHierarchyKey="activity.EntityHierarchyKey"
				:totalGuestInActivity="totalGuestInActivity"
				:isPackage="isPackage"
				:IsLargeGroup="IsLargeGroup"
				:enableRateDuration="
					activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3
				"
				:DisableLargeGroup="activeProductDetails.DisableLargeGroup"
				:maxPeople="activity.MaxPeople"
				:activity="activity"
				:disabled="disableGuestUi"
			/>
			<date-ui
				v-if="showDatePicker"
				:disabled="
					!IsLargeGroup &&
						!totalGuestInActivity &&
						activity.CapacityTypeKey != 2 &&
						activity.CapacityTypeKey != 3
				"
				:activityDate="activity.AppointmentDate"
				:entityHierarchyKey="activity.EntityHierarchyKey"
			/>
			<pre>hideUnselectedTimes: {{ hideUnselectedTimes }}</pre>

			<pre v-if="activity.Times">
activity.Times: {{ activity.Times.length }}</pre
			>

			<loader class="mt-3" v-if="getTimesLoading" />

			<div id="time-list" v-else>
				<large-group-times-ui
					v-if="
						(IsLargeGroup ||
							activity.CapacityTypeKey == 2 ||
							activity.CapacityTypeKey == 3) &&
							activity &&
							activity.Times
					"
					:isLoading="addToCartLoading"
					:totalGuestInActivity="totalGuestInActivity"
					:activity="activity"
					:isLargeGroup="IsLargeGroup"
					:hideUnselectedTimes="hideUnselectedTimes"
					@showUnselectedTimes="$emit('showUnselectedTimes', {})"
					:entityHierarchyKey="activity.EntityHierarchyKey"
				/>

				<times-ui
					v-if="
						activity &&
							activity.Times &&
							!IsLargeGroup &&
							activity.CapacityTypeKey != 2 &&
							activity.CapacityTypeKey != 3 &&
							showTimeSlots
					"
					:isLoading="addToCartLoading"
					:showAllTimes="showAllTimes"
					:totalGuestInActivity="totalGuestInActivity"
					:activity="activity"
					@selectedTimeChanged="selectedTimeChanged"
					:hideUnselectedTimes="hideUnselectedTimes"
					@showUnselectedTimes="$emit('showUnselectedTimes', {})"
					:entityHierarchyKey="activity.EntityHierarchyKey"
					@didSelectBook="didSelectBook"
				/>
				<div
					class="button _shadow  outline bg-mist call-to-book"
					v-if="callToBookOnly"
				>
					<i
						><svg
							xmlns="http://www.w3.org/2000/svg"
							height="24px"
							viewBox="0 0 24 24"
							width="24px"
							fill="#000000"
						>
							<path d="M0 0h24v24H0z" fill="none" />
							<path
								d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
							/></svg
					></i>
					<div class="c2b-info">
						<div>Call to book for this date</div>
						<a class="text-blue" :href="'tel:' + phone">{{ phone }}</a>
					</div>
				</div>
			</div>

			<p
				v-if="hideUnselectedTimes && IsLargeGroup && !getTimesLoading"
				class="mt-2 bg-gray p-1 border_radius flex_start"
			>
				<i class="material-icons mr-1">access_time</i>
				<a @click.prevent="$emit('showUnselectedTimes', {})" href
					>Show all available times</a
				>
			</p>

			<div
				v-if="
					!activity.HotelLatitude && activeProductDetails.NeedTransportation
				"
			>
				<p class="mt-1 bg-gray p-2 border_radius flex_start">
					Enter your hotel name to see available times.
				</p>
			</div>

			<div v-if="noTimesError.show">
				<p class="mt-1 bg-gray p-2 border_radius flex_start">
					<i class="material-icons mr-1">event_busy</i>
					<span v-if="activity.AppointmentTypeKey == 2">
						There is no availability for this date.
					</span>
					<span v-else-if="noTimesError.notes == ''">
						There are no available times for this date.
						<strong>Try another date.</strong>
					</span>
					<span v-else v-html="noTimesError.notes"></span>
				</p>
			</div>

			<div
				v-if="
					activeProductDetails.NeedTransportation &&
						!showAllTimes &&
						!getTimesLoading &&
						!IsLargeGroup &&
						activity &&
						activity.Times
				"
			>
				<transition name="slide-vertical">
					<a
						v-if="
							!hasPickupLocations && activity.Times && activity.Times.length
						"
						@click.prevent="showAllTimes = true"
						href
						class="bg-gray mt-3 pl-2 pr-2 pt-2 pb-2 border_radius flex_start"
						><span
							>There is no transportation available for this date. Select a
							different date or
							<strong class="text-blue">show all times</strong>.</span
						></a
					>
				</transition>
				<transition name="slide-vertical">
					<a
						data-v-if="
          !showAllTimes && activity && activity.Times && activity.Times.length
        "
						v-if="hasPickupLocations"
						@click.prevent="showAllTimes = true"
						style="display: block;"
						href
						class="bg-gray mt-3 pl-2 pr-2 pt-2 pb-2 border_radius flex_start"
					>
						Don't see a time that works?&nbsp;
						<strong class="text-blue">Show all times</strong>.
					</a>
				</transition>
			</div>

			<pre>productSubTotal: {{ productSubTotal }}</pre>

			<div class="silver_border_top pb-2 mt-3">
				<h3 class="mt-3">Overview</h3>

				<div v-html="activeProductDetails.Description"></div>
			</div>
			<div class="silver_border_top" v-if="client.Longitude">
				<location-map :client="client" />
			</div>
			<!-- <powered-by /> -->
		</div>

		<page-header
			:cleverBack="true"
			@cleverBackToList="cleverBackToList"
			:fixed="true"
		>
			<a
				@click.prevent="viewAllExp"
				href
				class="text-blue button link mt-0 mb-0 text-center pt-1 pb-1 text-right size-med"
				>View all experiences</a
			>
			<cart-icon slot="cart_bar" />
		</page-header>

		<transition name="slide-vertical">
			<page-footer
				v-show="
					activity.CapacityTypeKey == 2 ||
						activity.CapacityTypeKey == 3 ||
						IsLargeGroup ||
						modify ||
						activity.AppointmentTypeKey == appointmentKeys.anytime ||
						(activity.AppointmentTypeKey == appointmentKeys.date &&
							!callToBookOnly)
				"
			>
				<template v-slot:text>
					<h4>
						{{ totalGuestInActivity }}
						{{
							activity.OverrideRateLabel
								? totalGuestInActivity == 1
									? activity.RateLabelSingular
									: activity.RateLabelPlural
								: totalGuestInActivity == 1
								? 'guest'
								: 'guests'
						}}
					</h4>
					<small>
						Subtotal:
						<product-sub-total />
					</small>
				</template>
				<template v-slot:button>
					<button
						ref="doneAddingButton"
						:disabled="addToCartLoading || !addToCartEnabled || getTimesLoading"
						@click.prevent="progressCheckout()"
						href="#"
						:class="{
							button_loading: addToCartLoading,
							'scale-animation': addToCartEnabled,
						}"
						class="button blue ml-1 text-center"
					>
						{{ modify ? 'Save&nbsp;changes' : 'Add&nbsp;to&nbsp;cart' }}
					</button>
				</template>
			</page-footer>
		</transition>

		<post-add-to-cart-modals
			:addToCartLoading="addToCartLoading"
			:modelErrorsModal="modelErrorsModal"
			@modelErrorsModalOk="modelErrorsModalOk"
			:takenTimesModal="takenTimesModal"
			@takenTimesModalOk="takenTimesModalOk"
			:overlappedActivitiesModal="overlappedActivitiesModal"
			@overlappedActivitiesModalNo="overlappedActivitiesModalNo"
			@overlappedActivitiesModalYes="overlappedActivitiesModalYes"
			:isPackage="activeProductDetails.PackageKey"
		/>
	</div>
</template>

<script>
	// mixins
	import analyticsMixin from '../../mixins/analyticsMixin.js';
	import addToCart from '../../mixins/addToCart.js';
	import postTimeSelection from '../../mixins/postTimeSelection.js';

	import PostAddToCartModals from '../../components/PostAddToCartModals.vue';

	// components
	import Loader from '../../components/Loader.vue';
	import ProductSubTotal from '../../components/ProductSubTotal.vue';
	import GuestUi from '../../components/GuestUi.vue';
	import DateUi from '../../components/DateUi.vue';
	import TransportationUi from '../../components/TransportationUi.vue';
	import PrivateUi from '../../components/PrivateUi.vue';
	import LargeGroupTimesUi from '../../components/LargeGroupTimesUi.vue';
	import TimesUi from '../../components/TimesUi.vue';
	import CartIcon from '../../components/CartIcon.vue';
	import LocationMap from '../../components/LocationMap.vue';
	import PageFooter from '../../components/PageFooter.vue';
	import ProductImage from '../../components/ProductImage.vue';
	import ProductName from '../../components/ProductName.vue';

	import { mapActions, mapGetters, mapState } from 'vuex';

	export default {
		name: 'DetailsStart',
		props: [
			'activityRates',
			'activity',
			'isPackage',
			'IsLargeGroup',
			'noTimesError',
			'productName',
			'totalGuestInActivity',
			'hideUnselectedTimes',
			'prevRoute',
			'entityHierarchyKey',
			//"loadingTimes"
		],

		// handles addToCart(), modifiedActiveProductDetails, addToCartLoading
		mixins: [addToCart, analyticsMixin, postTimeSelection],
		activated: function() {
			console.log(`${this.activity.Name} activity activated()`, this.activity);

			if (
				(this.order && this.activity.OrderEntityKey) ||
				(this.activity && this.activity.Times)
			) {
				this.scrollToBookNow();
			} else {
				let el = document.querySelector('#individual_details');
				el.scrollTop = this.scrollTop;
			}
			//console.log("fromRoute.fullPath", this.fromRoute.fullPath);
			//console.log("totalGuestInActivity", this.totalGuestInActivity);
			//console.log("activity.AppointmentDate", this.activity.AppointmentDate);

			// if guests added, go to date picker view (not appointmentTypeKey of anytime (3))
			if (
				!this.fromRoute.fullPath.includes('date') &&
				this.totalGuestInActivity &&
				!this.activity.AppointmentDate &&
				this.activity.AppointmentTypeKey != this.appointmentKeys.anytime // anytime ticket
			) {
				let path =
					'/' +
					this.$route.params.client +
					'/activity/details/' +
					this.fromRoute.params.entityHierarchyKey +
					'/' +
					this.$route.params.clientAgentKey +
					'/dates/' +
					this.fromRoute.params.entityHierarchyKey;

				this.$router.push({
					path,
				});
			}
		},

		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.fromRoute = from;
			});
		},
		beforeRouteLeave: function(to, from, next) {
			console.log(to,from)
			let pathmatch = /\/\d*\/activity$/
			if (pathmatch.test(to.path) && window.parent) {
				window.parent.postMessage({detail_leave:true},"*")
			}
			let el = document.querySelector('#individual_details');
			this.scrollTop = el.scrollTop;

			// close private UI if displaying
			if (
				this.activity.EnablePrivateTours &&
				!this.activity.PrivateToursOnly &&
				this.$refs.privateUi
			)
				this.$refs.privateUi.edit = false;

			next();
		},

		data: function() {
			return {
				scrollTop: 0,
				showAllTimes: true,
				fromRoute: {
					fullPath: 'date',
				},
				appointmentKeys: {
					dateTime: 1,
					date: 2,
					anytime: 3,
				},
				hasMadePrivateSelection: false, // flag to enable guests selector component
			};
		},
		computed: {
			...mapState(['client', 'getTimesLoading', 'productSubTotal']),
			...mapGetters(['activeProductDetails']),
			showDatePicker() {
				if (this.activity.AppointmentTypeKey == this.appointmentKeys.anytime)
					return false;
				return true;
			},
			// controls enabling of activity GuestsUI button
			disableGuestUi() {
				if (this.activity.PrivateToursOnly) return false;
				if (
					!this.activity.EnablePrivateTours ||
					this.totalGuestInActivity ||
					this.modify ||
					this.hasMadePrivateSelection
				)
					return false;
				else return true;
			},
			showTimeSlots() {
				return !(
					this.activity.AppointmentTypeKey == this.appointmentKeys.date ||
					this.activity.AppointmentTypeKey == this.appointmentKeys.anytime
				);
			},
			callToBookOnly() {
				return (
					this.activity.AppointmentTypeKey == this.appointmentKeys.date && // activity is date only
					this.activity.Times.length == 1 && // only one time
					this.activity.Times[0].CallToBook // only time is 'call to book'
				);
			},
			phone() {
				return this.client.PublicPhoneNumber;
			},
			DisplayPrice() {
				//       console.log(this.activeProductDetails);
				if (this.activeProductDetails.OverrideAutoPrice) {
					return this.activeProductDetails.DisplayPrice;
				} else {
					return (
						'From ' +
						this.activeProductDetails.FromPrice +
						' / ' +
						this.activeProductDetails.FromPriceName
					);
				}
			},
			productType() {
				return this.$route.params.productType;
			},

			hasPickupLocations() {
				if (this.activity && this.activity.TimesClone) {
					return !!this.activity.TimesClone.find((tm) => {
						return tm.PickupLocations.length > 0;
					});
				}
				return false;
			},
			modify() {
				return this.$route.params.modify == 'modify' ? true : false;
			},

			addToCartEnabled() {
				if (this.activity.AppointmentTypeKey == 3 && this.totalGuestInActivity)
					return true;

				if (
					this.activity.AppointmentTypeKey == 2 &&
					this.activity.AppointmentDate
				)
					return true;

				if (
					this.activeProductDetails.NeedTransportation &&
					!this.activity.HotelLatitude
				) {
					return false;
				}

				if (
					!this.activity.AppointmentDate ||
					!this.totalGuestInActivity ||
					!this.activity.SelectedTimes ||
					this.activity.SelectedTimes.length == 0
				) {
					return false;
				}
				return true;
			},
		},
		components: {
			Loader,
			GuestUi,
			DateUi,
			TransportationUi,
			PrivateUi,
			TimesUi,
			LargeGroupTimesUi,
			ProductImage,
			ProductName,
			PageFooter,
			ProductSubTotal,
			CartIcon,
			LocationMap,
			PostAddToCartModals,
		},

		methods: {
			...mapActions(['viewAllExp', 'ajaxGetTimes', 'goToAddons']),
			progressCheckout() {
				// progresses checkout to next screen depending on AppointmentTypeKey
				if (!this.activity.AppointmentDate)
					this.activity.AppointmentDate = this.$moment().format('YYYY-MM-DD'); // assign arbritary date

				if (
					this.activity.AppointmentTypeKey == this.appointmentKeys.date ||
					this.activity.AppointmentTypeKey == this.appointmentKeys.anytime
				) {
					this.time = this.activity.Times[0]; // choose arbritary booking time
					if (!this.modify) {
						this.advancePostTimeSelection(
							'simple',
							this.activity.Times[0].Value,
							this.$route
						);
					} else {
						this.addToCart();
					}
				} else {
					{
						this.addToCart();
					}
				}
			},
			scrollToBookNow() {
				const overflow = document.getElementById('individual_details');
				const anchor = document.getElementById('book_now_heading');
				const rectOverflow = overflow.getBoundingClientRect();
				const rectAnchor = anchor.getBoundingClientRect();
				window
					.$('#individual_details')
					.animate({ scrollTop: rectAnchor.top - rectOverflow.top }, 0);
			},
			cleverBackToList() {
				this.$emit('cleverBackToList', {});
			},
			didSelectBook(time) {
				this.time = time;
				this.advancePostTimeSelection('simple', time.Value, this.$route);
			},
			selectedTimeChanged() {
				this.$emit('selectedTimeChanged', true);
			},
			// handles private tour selection status & forwards to guest UI automatically
			handlePrivateSelection(status) {
				this.activity.IsPrivateTour = status; // udpate private tour status'
				this.hasMadePrivateSelection = true; // choice has been made

				// if no guests selected go to guest picker UI
				if (!this.totalGuestInActivity) {
					let path =
						'/' +
						this.$route.params.client +
						'/activity/details/' +
						this.$route.params.id +
						'/' +
						this.$route.params.clientAgentKey +
						'/guests/' +
						this.$route.params.id;

					this.$router.push({
						path,
					});
				}
			},
		},
		watch: {
			'activeProductDetails.NeedTransportation': {
				handler(newVal) {
					if (!newVal) {
						// set Hotel info to null
						this.activity.HotelLatitude = null;
						this.activity.HotelLongitude = null;
						this.activity.HotelName = null;
						this.activity.HotelAddress = null;
						this.showAllTimes = true;
					} else {
						//this.showAllTimes = false;
					}
				},
			},
			'activity.AppointmentDate': {
				handler() {
					this.showAllTimes = !this.activeProductDetails.NeedTransportation;
				},
			},
		},
	};
</script>

<style></style>
